import React, { useEffect, useState, useCallback } from "react";
import { Breadcrumb, Button, message, Card, Input } from "antd";
import { style } from "../../Styles";
import { ReloadOutlined, MinusOutlined } from "@ant-design/icons";
import CustomTableComponents from "../CommonComponents/CustomTableComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  changeBundleStatus,
  deleteBundle,
  getBundles,
  filterBundles,
  setBundleFilter,
  resetBundleFilter,
} from "../../redux/bundleSlice";
import BundleDrawer from "./BundleDrawer";
import ActionButtonWithChangeStatus from "../CommonComponents/ActionButtonWithChangeStatus";
import { enumToUserFriendlyText } from "../../Utils/Imports/UserFriendlyEnum";
import Header from "../../global/Header/Header";
import { useTranslation } from "react-i18next";
import { getCardTypes } from "../../redux/cardTypeSlice";
import dayjs from "dayjs";
import FilteringDrawer from "./Filter/FilteringDrawer";

const Bundle = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { bundles } = useSelector((state) => state.bundles);
  const { profile } = useSelector((state) => state.users);

  const [filter, setFilter] = useState("");
  const [bundle, setBundle] = useState(undefined);
  const [isMakingApiCall, setMakingApiCall] = useState(true);
  const [cardTypes, setCardTypes] = useState([]);
  const [isBundleDrawerOpen, setBundleDrawerOpen] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([
    {
      label: t("bundleScreen.table.name"),
      key: "name",
    },
    {
      label: t("bundleScreen.table.price"),
      key: "price",
    },
    {
      label: t("bundleScreen.table.numberOfTrips"),
      key: "numberOfTrips",
    },
    {
      label: t("bundleScreen.table.type"),
      key: "type",
    },
    {
      label: t("bundleScreen.table.bundleValidityStart"),
      key: "bundleValidityFrom",
    },
    {
      label: t("bundleScreen.table.bundleValidityEnd"),
      key: "bundleValidityTo",
    },
    {
      label: t("bundleScreen.table.kioskType"),
      key: "kioskType",
    },
    {
      label: t("bundleScreen.table.status"),
      key: "active",
    },
  ]);
  const [isFilterDrawerOpen, setisFilterDrawerOpen] = useState(false);
  const [selectedOptionDropdownFields, setSelectedOptionDropdownFields] = useState({
    bundleValidityFrom: null,
    bundleValidityTo: null,
    bundleType: null,
    cardType: null,
    numberOfTrips: null,
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const bundleTypes = [
    { label: t("bundleScreen.filterDrawer.ticketType"), value: "TICKET_TYPE" },
    { label: t("bundleScreen.filterDrawer.topUpCardType"), value: "TOP_UP_CARD_TYPE" },
    { label: t("bundleScreen.filterDrawer.newCardType"), value: "NEW_CARD_TYPE" },
    { label: t("bundleScreen.filterDrawer.specialCardType"), value: "SPECIAL_CARD_TYPE" },
    { label: t("bundleScreen.filterDrawer.cardReplacementFee"), value: "CARD_REPLACEMENT_FEE" },
  ];

  const columns = [
    {
      title: t("bundleScreen.table.name"),
      key: "name",
      render: (record) => {
        return record?.name ? <span>{record.name}</span> : <MinusOutlined />;
      },
      sorter: (a, b) => a.name.length - b.name.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.price"),
      key: "price",
      render: (record) => {
        return record?.price ? <span>{`€ ${record.price}`}</span> : <MinusOutlined />;
      },
      sorter: (a, b) => a.name.length - b.name.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.numberOfTrips"),
      key: "numberOfTrips",
      render: (record) => {
        return record?.numberOfTrips ? <span>{record.numberOfTrips}</span> : <MinusOutlined />;
      },
      sorter: (a, b) => a.name.length - b.name.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.type"),
      key: "type",
      render: (record) => {
        return record?.type ? (
          <span>
            {record.type === "TICKET_TYPE" ? (
              <div>{t("transactionScreen.transactionTypes.ticket")}</div>
            ) : record.type === "NEW_CARD_TYPE" ? (
              <div>{t("transactionScreen.transactionTypes.newCard")}</div>
            ) : record.type === "TOP_UP_CARD_TYPE" ? (
              <div>{t("transactionScreen.transactionTypes.topupCard")}</div>
            ) : record.type === "SPECIAL_CARD_TYPE" ? (
              <div>{t("transactionScreen.transactionTypes.specialCard")}</div>
            ) : record.type === "CARD_REPLACEMENT_FEE" ? (
              <div>{t("transactionScreen.transactionTypes.cardReplacement")}</div>
            ) : (
              <div>-</div>
            )}

          </span>
        ) : (
          <MinusOutlined />
        );
      },
      sorter: (a, b) => a.name.length - b.name.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.bundleValidityStart"),
      key: "bundleValidityFrom",
      render: (record) => {
        return record?.bundleValidityFrom ? (
          dayjs(record?.bundleValidityFrom).isBefore(dayjs().startOf("day")) ? (
            <span style={{ ...style.dateActif }}>
              {dayjs(record?.bundleValidityFrom).format("DD-MM-YYYY")}
            </span>
          ) : (
            <span style={style.dateInactif}>
              {dayjs(record?.bundleValidityFrom).format("DD-MM-YYYY")}
            </span>
          )
        ) : (
          <MinusOutlined />
        );
      },
      sorter: (a, b) => a.name.length - b.name.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.bundleValidityEnd"),
      key: "bundleValidityTo",
      render: (record) => {
        return record?.bundleValidityTo ? (
          dayjs(record?.bundleValidityTo).isAfter(dayjs().startOf("day")) ? (
            <span style={style.dateActif}>
              {dayjs(record?.bundleValidityTo).format("DD-MM-YYYY")}
            </span>
          ) : (
            <span style={style.dateInactif}>
              {dayjs(record?.bundleValidityTo).format("DD-MM-YYYY")}
            </span>
          )
        ) : (
          <MinusOutlined />
        );
      },
      sorter: (a, b) => a.name.length - b.name.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.kioskType"),
      key: "type",
      render: (record) => {
        return record?.kioskType ? (
          <span>{enumToUserFriendlyText(record?.kioskType)}</span>
        ) : (
          t("bundleScreen.table.all")
        );
      },
      sorter: (a, b) => a.kioskType.length - b.kioskType.length,
      show: true,
    },
    {
      title: t("bundleScreen.table.status"),
      key: "active",
      render: (record) => {
        return (
          <span style={style.dataContainer}>
            {record.active ? (
              <div style={style.statusActif}>{t("statuses.active")}</div>
            ) : (
              <div style={style.statusInactif}>{t("statuses.inactive")}</div>
            )}
          </span>
        );
      },
      sorter: (a, b) => a?.active - b?.active,
      show: true,
    },
    {
      title: t("bundleScreen.table.actions"),
      key: "actions",
      render: (text, record) => (
        <ActionButtonWithChangeStatus
          record={record}
          onDelete={() => handleDeleteBundle(record)}
          onRowClick={() => handleSelectedRow(record)}
          onChangeStatus={() => handleChangeStatus(record)}
        />
      ),
      show: true,
    },
  ];

  const fetchBundles = useCallback(() => {
    dispatch(getBundles())
      .unwrap()
      .then(() => setMakingApiCall(false))
      .catch(() => setMakingApiCall(false));
  }, [dispatch]);

  useEffect(() => {
    fetchBundles();
  }, [fetchBundles]);

  useEffect(() => {
    if (bundles && bundles.length > 0) {
      setIsDataLoaded(true);
    } else {
      setIsDataLoaded(false);
    }
  }, [bundles]);

  useEffect(() => {
    console.log("isFiltered:", isFiltered);
    if (!isFiltered) {
      setMakingApiCall(true);
      dispatch(getBundles())
        .unwrap()
        .then((data) => {
          console.log("Initial getBundles response:", data);
          setMakingApiCall(false);
        })
        .catch((error) => {
          console.error("Initial getBundles error:", error);
          setMakingApiCall(false);
        });
    }
  }, [dispatch, isFiltered]);

  const handleSelectDropdownsChange = (key, value) => {
    setSelectedOptionDropdownFields((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const onApplyFilter = (values) => {
    console.log("Applying filter with values:", values);
    if (
      values &&
      Object.values(values).some((value) => value !== null && value !== undefined)
    ) {
      const payload = {};
      if (values.bundleValidityFrom) {
        payload.bundleValidityFrom = values.bundleValidityFrom;
      }
      if (values.bundleValidityTo) {
        payload.bundleValidityTo = values.bundleValidityTo;
      }
      if (values.bundleType) {
        payload.type = values.bundleType;
      }
      if (values.cardType) {
        payload.cardTypeId = values.cardType;
      }
      if (values.numberOfTrips) {
        payload.numberOfTrips = values.numberOfTrips;
      }

      console.log("Filter payload:", payload);
      dispatch(setBundleFilter(payload));

      // Save the filter state for repopulation
      setSelectedOptionDropdownFields(values);

      setMakingApiCall(true);
      dispatch(filterBundles(payload))
        .unwrap()
        .then((data) => {
          setIsFiltered(true);
          setMakingApiCall(false);
          setisFilterDrawerOpen(false);
        })
        .catch((error) => {
          setMakingApiCall(false);
        });
    } else {
      dispatch(resetBundleFilter());
      setSelectedOptionDropdownFields({
        bundleValidityFrom: null,
        bundleValidityTo: null,
        bundleType: null,
        cardType: null,
        numberOfTrips: null,
      });
      setIsFiltered(false);
      setisFilterDrawerOpen(false);
    }
  };

  const openFilterDrawer = () => {
    fetchCardType();
    setisFilterDrawerOpen(true);
  };

  const closeFilterDrawer = () => {
    setisFilterDrawerOpen(false);
  };

  const onResetFilter = () => {
    dispatch(resetBundleFilter());
    setSelectedOptionDropdownFields({
      bundleValidityFrom: null,
      bundleValidityTo: null,
      bundleType: null,
      cardType: null,
      numberOfTrips: null,
    });
    setIsFiltered(false);
    setisFilterDrawerOpen(true); // Reopen the filter drawer with reset state
  };

  const filtredData = bundles?.filter((item) => {
    if (!item) return false;
    const searchTerm = filter.toLowerCase();
    return (
      (item?.name?.toLowerCase()?.includes(searchTerm) || false) ||
      (item?.price?.toString().toLowerCase().includes(searchTerm) || false) ||
      (item?.bundleValidityFrom
        ? dayjs(item.bundleValidityFrom).format("YYYY-MM-DD").includes(searchTerm)
        : false) ||
      (item?.bundleValidityTo
        ? dayjs(item.bundleValidityTo).format("YYYY-MM-DD").includes(searchTerm)
        : false) ||
      (item?.numberOfTrips?.toString().includes(searchTerm) || false) ||
      (item?.kioskType?.toLowerCase()?.includes(searchTerm) || false) ||
      (item?.type?.toLowerCase()?.includes(searchTerm) || false) ||
      (item?.cardType?.name?.toLowerCase()?.includes(searchTerm) || false)
    );
  }) || [];

  const handleSelectedRow = (record) => {
    setBundle(record);
    showDrawer();
  };

  const fetchCardType = () => {
    dispatch(getCardTypes())
      .unwrap()
      .then(() => {
        setMakingApiCall(false);
      })
      .catch(() => setMakingApiCall(false));
  };

  const showDrawer = () => {
    fetchCardType();
    setBundleDrawerOpen(true);
  };

  const onDrawerClose = () => {
    setBundleDrawerOpen(false);
    setBundle(undefined);
  };

  const handleDeleteBundle = (record) => {

    if(record?.type != "CARD_REPLACEMENT_FEE") {
      dispatch(deleteBundle(record.id))
        .unwrap()
        .then(() => {
          message.success(t("bundleScreen.messages.bundleDeletedSuccessfully"));
        })
        .catch((e) => {
          message.error(e.message);
        });
    } else if (profile?.user?.roles.includes("SUPER_ADMIN_ROLE")) {
      dispatch(changeBundleStatus({ id: record.id, active: !record.active }))
      .unwrap()
      .then(() => {
        message.success(t("bundleScreen.messages.bundleStatusUpdatedSuccessfully"));
      })
      .catch((e) => {
        message.error(e.message);
      });
    } else {
      message.error(t("bundleScreen.messages.youAreNotAllowedToDeletedThisbundle"));
    }
    
  };

  const handleChangeStatus = (record) => {
    if(record.type != "CARD_REPLACEMENT_FEE") {
      dispatch(changeBundleStatus({ id: record.id, active: !record.active }))
        .unwrap()
        .then(() => {
          message.success(t("bundleScreen.messages.bundleStatusUpdatedSuccessfully"));
        })
        .catch((e) => {
          message.error(e.message);
        });
    } else if (profile?.user?.roles.includes("SUPER_ADMIN_ROLE")) {
      dispatch(changeBundleStatus({ id: record.id, active: !record.active }))
      .unwrap()
      .then(() => {
        message.success(t("bundleScreen.messages.bundleStatusUpdatedSuccessfully"));
      })
      .catch((e) => {
        message.error(e.message);
      });
    } else {
      message.error(t("bundleScreen.messages.youAreNotAllowedToDisableThisbundle"));
    }
  };

  const createdCsv = filtredData.map((item) => {
    return {
      ...item,
      bundleValidityFrom: item?.bundleValidityFrom
        ? dayjs(item?.bundleValidityFrom).format("DD-MM-YYYY")
        : "-",
      bundleValidityTo: item?.bundleValidityTo
        ? dayjs(item?.bundleValidityTo).format("DD-MM-YYYY")
        : "-",
      kioskType: item?.kioskType
        ? enumToUserFriendlyText(item?.kioskType)
        : t("bundleScreen.table.all"),
      type:
        item.type === "TICKET_TYPE"
          ? t("transactionScreen.transactionTypes.ticket")
          : item.type === "NEW_CARD_TYPE"
          ? t("transactionScreen.transactionTypes.newCard")
          : item.type === "TOP_UP_CARD_TYPE"
          ? t("transactionScreen.transactionTypes.topupCard")
          : item.type === "SPECIAL_CARD_TYPE"
          ? t("transactionScreen.transactionTypes.specialCard")
          : "-",
      active: item.active ? t("statuses.active") : t("statuses.inactive"),
    };
  });

  const handleGenerateCsv = (event, done) => {
    const promise = async () => {
      setCsvHeaders([
        {
          label: t("bundleScreen.table.name"),
          key: "name",
        },
        {
          label: t("bundleScreen.table.price"),
          key: "price",
        },
        {
          label: t("bundleScreen.table.numberOfTrips"),
          key: "numberOfTrips",
        },
        {
          label: t("bundleScreen.table.type"),
          key: "type",
        },
        {
          label: t("bundleScreen.table.bundleValidityStart"),
          key: "bundleValidityFrom",
        },
        {
          label: t("bundleScreen.table.bundleValidityEnd"),
          key: "bundleValidityTo",
        },
        {
          label: t("bundleScreen.table.kioskType"),
          key: "kioskType",
        },
        {
          label: t("bundleScreen.table.status"),
          key: "active",
        },
      ]);
    };

    promise().then(done(true));
  };

  const primaryColor = process.env.REACT_APP_PRIMARY_COLOR;

  useEffect(() => {
    console.log("Bundles state:", bundles);
  }, [bundles]);

  return (
    <>
      <Header
        addButtonText={t("bundleScreen.header.addBundle")}
        onAddButtonClick={() => showDrawer()}
        onSearch={(e) => {
          setFilter(e.target.value);
        }}
        searchPlaceholder={t("bundleScreen.header.search")}
        addButtonBackgroundColor={primaryColor}
        addButtonBorderColor={primaryColor}
        addButtonTextColor={"#ffffff"}
        onReload={fetchBundles}
        showAddButton={true}
        BreadcrumbItems={[
          {
            title: t("bundleScreen.header.title"),
          },
        ]}
        showFilterButton={true}
        onClickFilterButton={() => {
          openFilterDrawer();
        }}
        showBreadcrumb={true}
        showExportCSV={true}
        csvHeaders={csvHeaders}
        csvData={createdCsv}
        generateCSVfn={handleGenerateCsv}
        csvDataMiddleFileName={"Bundle"}
      />
      <Card style={{ margin: "20px 0" }}>
        <CustomTableComponents
          isMakingApiCall={isMakingApiCall}
          columns={columns.filter((column) => column.show)}
          dataArray={isDataLoaded ? filtredData : []}
          handleDoubleClickRow={(record) => handleSelectedRow(record)}
          handleSelectedRow={() => {}}
        />
        {isBundleDrawerOpen && (
          <BundleDrawer onClose={onDrawerClose} bundleId={bundle?.id} userRoles={profile?.user?.roles} />
        )}

        {isFilterDrawerOpen && (
          <FilteringDrawer
            closeFilteringDrawer={closeFilterDrawer}
            isFilteringDrawerOpened={isFilterDrawerOpen}
            resetFilter={onResetFilter}
            loading={false}
            formName={"Bundles filter"}
            title={t("bundleScreen.filterDrawer.title")}
            onSave={onApplyFilter} // Pass the filtering function
            bundleTypes={bundleTypes}
            selectedOptionOfDropdownFields={selectedOptionDropdownFields}
            setSelectedOptionOfDropdownFields={handleSelectDropdownsChange}
          />
        )}
      </Card>
    </>
  );
};

export default Bundle;